module.exports = __webpack_public_path__ + "assets/img/sfytj.0971cbde.png";